import {
  RequestBodyDownloadSponsorDashboard,
  RequestBodySponsorDashboard,
} from '@/pages/SponsorDashboard/store/types';
import { AxiosInstance } from 'axios';

export default class SponsorDashboardAPI {
  client: AxiosInstance;
  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async fetchSponsorTopCardsData(data: RequestBodySponsorDashboard) {
    return this.client.post(
      'v2/organizations/sponsor-dashboard-metrics/',
      data,
    );
  }

  async fetchSponsorBenchmarkData(data: RequestBodySponsorDashboard) {
    return this.client.post(
      'v2/organizations/sponsor-dashboard-projections/',
      data,
    );
  }

  async fetchSponsorCounterpartyData(data: RequestBodySponsorDashboard) {
    return this.client.post(
      'v2/organizations/sponsor-dashboard-counterparty-exposure/',
      data,
    );
  }

  async fetchSponsorComplianceData(data: RequestBodySponsorDashboard) {
    return this.client.post(
      'v2/organizations/sponsor-dashboard-compliance/',
      data,
    );
  }

  async fetchSponsorAlertsData(data: RequestBodySponsorDashboard) {
    return this.client.post('v2/organizations/sponsor-dashboard-alerts/', data);
  }

  async downloadSponsorDashboard(payload: RequestBodyDownloadSponsorDashboard) {
    const url = 'v2/organizations/download-sponsor-dashboard-report/';
    return this.client.post(url, payload);
  }

  async fetchSponsorTransactionDetailsData(data: RequestBodySponsorDashboard) {
    return this.client.post(
      'v2/organizations/sponsor-dashboard-transaction-details/',
      data,
    );
  }

  async fetchSponsorFXMetricsData(data: RequestBodySponsorDashboard) {
    return this.client.post(
      'v2/organizations/sponsor-dashboard-fx-metrics/',
      data,
    );
  }

  async fetchSponsorFXComplianceData(data: RequestBodySponsorDashboard) {
    return this.client.post(
      'v2/organizations/sponsor-dashboard-fx-compliance/',
      data,
    );
  }

  async fetchSponsorFXTransactionDetailsData(data: RequestBodySponsorDashboard) {
    return this.client.post(
      'v2/organizations/sponsor-dashboard-fx-transaction-details/',
      data,
    );
  }

  async fetchSponsorCommodityMetricsData(data: RequestBodySponsorDashboard) {
    return this.client.post(
      'v2/organizations/sponsor-dashboard-commodity-metrics/',
      data,
    );
  }

  async fetchSponsorCommodityComplianceData(data: RequestBodySponsorDashboard) {
    return this.client.post(
      'v2/organizations/sponsor-dashboard-commodity-compliance/',
      data,
    );
  }

  async fetchSponsorCommodityTransactionDetailsData(
    data: RequestBodySponsorDashboard,
  ) {
    return this.client.post(
      'v2/organizations/sponsor-dashboard-commodity-transaction-details/',
      data,
    );
  }

  async fetchSponsorPricingData(data: RequestBodySponsorDashboard) {
    return this.client.post(
      'v2/organizations/sponsor-dashboard-pricing/',
      data,
    );
  }

  async fetchSponsorInstrumentAvailability(data: RequestBodySponsorDashboard) {
    return this.client.post(
      'v2/organizations/sponsor-dashboard-instrument-availability/',
      data,
    );
  }

  async fetchSponsorFXCounterpartyExposure(data: RequestBodySponsorDashboard) {
    return this.client.post(
      'v2/organizations/sponsor-dashboard-fx-counterparty-exposure/',
      data,
    );
  }

  async fetchSponsorCommodityCounterpartyExposure(
    data: RequestBodySponsorDashboard,
  ) {
    return this.client.post(
      'v2/organizations/sponsor-dashboard-commodity-counterparty-exposure/',
      data,
    );
  }
}
